import type { ProductKind } from '../../utils/productKind';

/**
 * Wording of the wizard's first-product step for the chosen Type. Product
 * keeps the step's original copy; Service names a service instead.
 */

export interface FirstProductStepCopy {
  heading: string;
  supportingCopy: string;
  primaryLabel: string;
  skipLabel: string;
  skipAccessibilityHint: string;
  /** The line under the intro that switches to the other type. */
  switchPrompt: string;
  switchLabel: string;
  /** Title of the alert shown once the item is saved. */
  createdTitle: string;
  /** Used in the saved alert when the name is blank. */
  fallbackName: string;
}

const FIRST_PRODUCT_STEP_COPY: Record<ProductKind, FirstProductStepCopy> = {
  product: {
    heading: 'Add your first product',
    supportingCopy:
      'Add one real product so you can make your first sale. You can edit or add more later.',
    primaryLabel: 'Add product',
    skipLabel: 'Skip product for now',
    skipAccessibilityHint: 'Continue this guide without creating a product',
    switchPrompt: 'Selling a service?',
    switchLabel: 'Add a service instead',
    createdTitle: 'Product added',
    fallbackName: 'Your product',
  },
  service: {
    heading: 'Add your first service',
    supportingCopy:
      'Add one real service so you can make your first sale. You can edit or add more later.',
    primaryLabel: 'Add service',
    skipLabel: 'Skip service for now',
    skipAccessibilityHint: 'Continue this guide without creating a service',
    switchPrompt: 'Selling products?',
    switchLabel: 'Add a product instead',
    createdTitle: 'Service added',
    fallbackName: 'Your service',
  },
};

export const getFirstProductStepCopy = (
  kind: ProductKind,
): FirstProductStepCopy => FIRST_PRODUCT_STEP_COPY[kind];
